<template>
  <div>
    <v-form ref="customerNetPricesForm">
      <v-simple-table dense class="elevation-1 bordered--table pa-1">
        <template v-slot:default>
          <thead>
            <tr>
              <!-- <th width="5%">#</th> -->
              <th width="30%">{{ $t('message.layout.product') }}</th>
              <th width="17%">{{ $t('message.customer.validUntil') }}</th>
              <th width="16%" class="text-right">{{ $t('message.product.costPrice') }}</th>
              <th width="16%" class="text-right">{{ $t('message.product.salePrice') }}</th>
              <th width="16%">{{ $t('message.order.netprice') }}</th>
              <th width="5%"></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="listOfNetPrices && listOfNetPrices.length">
              <tr v-for="(item, index) in listOfNetPrices" :key="item.id" :style="item.isGoingToExpire ? 'background-color: #ffebeb' : ''">
                <!-- <td>{{item.productid}}</td> -->
                <td>{{ item.productName }}</td>
                <td>
                  <v-menu :close-on-content-click="false" v-model="item.validUntilMenu" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }"><!-- prepend-icon="event" :label="$t('message.customer.validUntil')"-->
                    <v-text-field @keydown.tab="closeCalendar(index)" class="my-1" outlined hide-details dense clearable
                    v-on="on" v-model="item.validuntil" :rules="$_requiredValidation"
                    @click:clear="$nextTick(() => item.validUntilPicker = null)"></v-text-field>
                  </template>
                  <v-date-picker color="primary" @change="changesMade();item.validuntil = $formatter.formatDate(item.validUntilPicker, 'YYYY-MM-DD', 'DD.MM.YYYY')" v-model="item.validUntilPicker" @input="item.validUntilMenu = false" first-day-of-week='1'></v-date-picker>
                </v-menu>
                </td>
                <td class="text-right">{{ item.costprice }}</td>
                <td class="text-right">{{ item.productsalesprice }}</td>
                <td>
                  <v-text-field class="my-1 text-right-align-price" outlined hide-details :rules="!item.salesprice ? $_requiredValidation : $_norwegianNumberValidation" dense v-model="item.salesprice" @change="changesMade()"></v-text-field>
                </td>
                <td>
                  <v-btn small fab icon color="error" @click="deleteProductRow(index, item.id)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="6">
                  <v-alert prominent text type="info" class="mt-2 py-1">
                    <v-row align="center">
                      <v-col class="grow">{{ $t('message.common.noResults') }}</v-col>
                    </v-row>
                  </v-alert>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-form>
    <v-row class="pl-1">
      <v-col cols="4">
        <v-autocomplete clearable v-model="selectedProductId" :ref="'searchInput'" @keyup="$event.keyCode !== 13 ? loadProducts(`searchInput`, $event) : ''" dense
          @change="addNewProductToList" outlined :label="$t('message.invoice.searchProduct')" :items="listOfProducts" item-text="product_name" item-value="id"></v-autocomplete>
      </v-col>
      <!-- <v-col cols="1">
        <v-btn fab dark x-small color="primary" @click="addNewProductToList">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-col> -->
      <v-spacer></v-spacer>
      <v-col cols="1">
        <v-btn dark color="success" @click="saveList">{{ $t('message.common.save') }}</v-btn> <!-- @click="addNewProductToList" -->
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data () {
    return {
      listOfNetPrices: [],
      listOfProducts: [],
      selectedProductId: 0,
      customerId: this.$route.params.crm_id,
      expiringDateRange: null
    }
  },
  mounted () {
    this.expiringDateRange = moment().add(1, 'M').add(1, 'd')
    this.getListHandler()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.CUSTOMERNETPRICES) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      let query = {
        'expand': [{
          'Model': 'Product',
          'on_field': 'Id',
          'on_parent_field': 'productid',
          'select': ['Name', 'Number', 'CostPrice', 'SalesPrice']
        }],
        'filter': `customerid eq '${this.customerId || 0}'`
      }
      this.$_executeApi('post', `${this.CUSTOMERNETPRICES}/query`, query)
        .then((response) => {
          let list = this.$formatter.cloneVariable(response.data)
          list.forEach(element => {
            element.productName = element.product_number ? `${element.product_number} - ${element.product_name}` : element.product_name
            element.costprice = element.product_costprice
            element.productsalesprice = element.product_salesprice
            element.isGoingToExpire = moment().isSame(moment(element.validuntil, 'DD.MM.YYYY'), 'd') || moment(element.validuntil, 'DD.MM.YYYY').isBetween(moment(), this.expiringDateRange, 'd')
            element.validUntilPicker = this.$formatter.formatDate(element.validuntil, 'DD.MM.YYYY', 'YYYY-MM-DD')
          })
          let transformData = {
            number: { list: ['costprice', 'salesprice', 'productsalesprice'], format: 'replaceDotWithComma' },
            date: { list: ['validuntil'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' }
          }
          list = this.$_formatListModel(list, transformData)
          this.listOfNetPrices = list
        })
    },
    // Searching products
    loadProducts (term, event) {
      if ([30, 32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term].lazySearch
      if (searchText !== null) {
        this.$_executeApi('post', `products/search_for_products?term=${searchText}&excludeopenstructure=true`).then((response) => {
          this.listOfProducts = []
          let existingProducts = this.listOfNetPrices.map(x => x.productid)
          let list = response.data.filter(x => !existingProducts.includes(x.id))
          if (list.length > 0) {
            list.forEach(element => {
              element.product_name = element.number ? `${element.number} - ${element.name}` : element.name
            })
            this.listOfProducts = list
          }
        })
      }
    },
    addNewProductToList () {
      let product = this.listOfProducts.find(x => x.id === this.selectedProductId)
      if (product) {
        let netPriceObj = { productName: product.product_name, customerid: this.customerId, productid: product.id, costprice: product.costprice, salesprice: 0, validuntil: '', productsalesprice: product.salesprice }
        let transformData = { number: { list: ['costprice', 'salesprice', 'productsalesprice'], format: 'replaceDotWithComma' } }
        netPriceObj = this.$_formatModel(netPriceObj, transformData)
        this.$set(this.listOfNetPrices, (this.listOfNetPrices.length), netPriceObj)
        this.$store.commit('isChangesMade', true)
      }
      setTimeout(() => { this.selectedProductId = 0 })
    },
    saveList () {
      if (this.$refs.customerNetPricesForm.validate()) {
        let netPricesModel = this.$formatter.cloneVariable(this.listOfNetPrices)
        let transformData = {
          number: { list: ['costprice', 'salesprice'], format: 'replaceCommaWithDot' },
          date: { list: ['validuntil'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DD' }
        }
        netPricesModel = this.$_formatListModel(netPricesModel, transformData)
        let netPricesJSON = { 'items': this.$formatter.cloneVariable(netPricesModel) }
        this.$_executeApi('post', `customernetprices/bulk_save/${this.customerId}`, netPricesJSON).then(response => {
          this.getListHandler()
          this.$store.commit('isChangesMade', false)
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
        })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    deleteProductRow (index, id) {
      if (this.listOfNetPrices[index].id) {
        let payload = { ids: [id], url: `${this.CUSTOMERNETPRICES}/delete_multiple`, module: this.CUSTOMERNETPRICES }
        this.$store.commit('showDeleteDialog', payload)
      } else {
        this.listOfNetPrices.splice(index, 1)
      }
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    closeCalendar (index) {
      this.$set(this.listOfNetPrices, index, { ...this.listOfNetPrices[index], validUntilMenu: false })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
<style>
.text-right-align-price input {
  text-align: right !important;
}
</style>
